import { SearchContextNav } from '#/modules/search/components/Context/SearchContextNav/SearchContextNav';
import type { SearchContextHeaderData } from '#/modules/search/containers/SearchContextHeader/SearchContextHeaderData';

type Props = {
  searchContext: SearchContextHeaderData;
};

export function ListingViewHeaderSearchContext({ searchContext }: Props) {
  return <SearchContextNav searchContext={searchContext} position="top" />;
}
